import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-modal-info",
    templateUrl: "./modal-info.component.html",
    styleUrls: ["./modal-info.component.scss"]
})
export class ModalInfoComponent {
    public mensaje = "";

    constructor(private activeModal: NgbActiveModal) { }

    public cerrar(mensaje: string): void {
        this.activeModal.close(mensaje);
    }
}
